import { CopyWrapper } from '@/components/ui';
import { Check, Star, Zap, X, Phone } from 'lucide-react';
import { Header } from '../landing/components/Header';
import { Footer } from '../landing/components/Footer';
import { Helmet } from 'react-helmet-async';
import { SubscribeButton } from '@/components/ui/SubscribeButton'; // Certifique-se que o caminho está correto
import { getUserData } from '@/utils/cookies';
import {
	WHATSAPP_LINK_BENEFIT,
	WHATSAPP_NUMBER_COPY,
	WHATSAPP_NUMBER_FORMATTED,
} from '@/constants/whatsapp';

export const PlanSelectionPage = () => {
	const userData = getUserData();
	const userMetadata = (userData?.metadata as any) || {};
	const shouldShowSubscribe =
		!!userData?.id &&
		!!userMetadata.company_code &&
		userData.is_member === false;

	return (
		<div className="flex min-h-screen flex-col bg-zinc-50 font-sans">
			<Helmet>
				<title>Nossos Planos de Saúde Mental | Plumaa</title>
				<meta
					name="description"
					content="Confira os planos Plumaa para colaboradores: Plano Free, Go e Starter. Terapia online acessível com psicólogos qualificados."
				/>
			</Helmet>

			<Header />

			<main className="w-full flex-1 animate-fade-in">
				<section className="w-full bg-zinc-50 px-4 py-16 md:py-24">
					<div className="mx-auto max-w-7xl space-y-12 md:space-y-16">
						<div className="mx-auto max-w-3xl space-y-4 text-center">
							<h1 className="text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">
								Planos disponíveis para seus colaboradores
							</h1>
							<p className="text-lg text-zinc-500">
								Olá! Escolha abaixo a melhor opção para sua
								saúde mental e bem-estar.
							</p>
						</div>

						<div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-3">
							{/* Card Free */}
							<div className="group relative flex flex-col overflow-hidden rounded-2xl border-2 border-zinc-200/60 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md xl:p-8">
								<div className="mb-6">
									<h3 className="flex items-center gap-2 text-lg font-bold text-gray-900">
										<div className="rounded-lg bg-zinc-100 p-2 text-primary transition-colors group-hover:bg-primary/10">
											<Zap className="size-5" />
										</div>
										Plano Free
									</h3>
									<div className="mt-4 flex items-baseline gap-1">
										<span className="text-4xl font-bold tracking-tight text-gray-900">
											R$ 0,00
										</span>
										<span className="text-sm font-semibold text-gray-500">
											/mês
										</span>
									</div>
									<p className="mt-2 text-sm font-medium text-zinc-500">
										Para o colaborador
									</p>
								</div>

								<ul className="mb-8 flex-1 space-y-4">
									<li className="flex items-start gap-3 text-sm text-zinc-600">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>
											Acesso completo à plataforma digital
										</span>
									</li>
									<li className="flex items-start gap-3 text-sm text-zinc-600">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>
											1 Prática terapêutica em grupo ao
											vivo
										</span>
									</li>
									<li className="flex items-start gap-3 text-sm text-zinc-600">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>Comunidade de apoio</span>
									</li>
									<li className="flex items-start gap-3 text-sm text-zinc-400 line-through decoration-zinc-400/50">
										<X className="size-5 shrink-0 text-zinc-300" />
										<span>
											Sessões individuais mensais com
											psicólogos
										</span>
									</li>
								</ul>

								{shouldShowSubscribe && (
									<SubscribeButton
										plan="FREE"
										className="w-full border border-zinc-200 bg-transparent py-2 text-zinc-600 transition-all hover:border-primary hover:bg-primary/5 hover:text-primary"
									/>
								)}
							</div>

							{/* Card Go */}
							<div className="group flex flex-col rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-lg xl:p-8">
								<div className="mb-6">
									<h3 className="flex items-center gap-2 text-lg font-bold text-gray-900">
										<div className="rounded-lg bg-zinc-100 p-2 text-zinc-500 transition-colors group-hover:bg-primary/10 group-hover:text-primary">
											<Star className="size-5" />
										</div>
										Plano Go
									</h3>
									<div className="mt-4 flex items-baseline gap-1">
										<span className="text-4xl font-bold tracking-tight text-gray-900">
											R$ 175,00
										</span>
										<span className="text-sm font-semibold text-gray-500">
											/mês
										</span>
									</div>
									<p className="mt-2 text-sm font-medium text-zinc-500">
										Para o colaborador
									</p>
								</div>

								<ul className="mb-8 flex-1 space-y-4">
									<li className="flex items-start gap-3 text-sm font-medium text-gray-900">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>
											2 Sessões individuais mensais com
											psicólogos
										</span>
									</li>
									<li className="flex items-start gap-3 text-sm text-zinc-600">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>
											Acesso completo à plataforma digital
										</span>
									</li>
									<li className="flex items-start gap-3 text-sm text-zinc-600">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>
											1 Prática terapêutica em grupo ao
											vivo
										</span>
									</li>
									<li className="flex items-start gap-3 text-sm text-zinc-600">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>Comunidade de apoio</span>
									</li>
								</ul>

								{shouldShowSubscribe && (
									<SubscribeButton
										plan="GO"
										className="w-full border border-zinc-200 bg-transparent py-2 text-zinc-600 transition-all hover:border-primary hover:bg-primary/5 hover:text-primary"
									/>
								)}
							</div>

							{/* Card Starter */}
							<div className="relative flex flex-col overflow-hidden rounded-2xl border-2 border-amber-400 bg-white p-6 shadow-xl ring-4 ring-amber-400/10 transition-all duration-300 hover:shadow-2xl xl:p-8">
								<div className="mb-6">
									<h3 className="flex items-center gap-2 text-lg font-bold text-gray-900">
										<div className="rounded-lg bg-amber-50 p-2 text-amber-500">
											<Star className="size-5 fill-amber-500" />
										</div>
										Plano Starter
									</h3>
									<div className="mt-4 flex items-baseline gap-1">
										<span className="text-4xl font-bold tracking-tight text-gray-900">
											R$ 350,00
										</span>
										<span className="text-sm font-semibold text-gray-500">
											/mês
										</span>
									</div>
									<p className="mt-2 text-sm font-medium text-zinc-500">
										Para o colaborador
									</p>
								</div>

								<ul className="mb-8 flex-1 space-y-4">
									<li className="flex items-start gap-3 text-sm font-medium text-gray-900">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>
											4 Sessões individuais mensais com
											psicólogos
										</span>
									</li>
									<li className="flex items-start gap-3 text-sm text-zinc-600">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>
											Acesso completo à plataforma digital
										</span>
									</li>
									<li className="flex items-start gap-3 text-sm text-zinc-600">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>
											1 Prática terapêutica em grupo ao
											vivo
										</span>
									</li>
									<li className="flex items-start gap-3 text-sm text-zinc-600">
										<Check className="size-5 shrink-0 text-green-500" />
										<span>Comunidade de apoio</span>
									</li>
								</ul>

								{shouldShowSubscribe && (
									<SubscribeButton
										plan="STARTER"
										className="border-transparent bg-amber-500 text-white hover:bg-amber-600"
									/>
								)}
							</div>
						</div>
					</div>
				</section>
				{!shouldShowSubscribe && (
					<section className="w-full border-t border-zinc-100 bg-white px-4 py-20">
						<div className="mx-auto max-w-md space-y-10 text-center">
							<div className="space-y-3">
								<h2 className="text-2xl font-bold text-gray-900 md:text-3xl">
									Fale com a gente
								</h2>
								<p className="text-lg leading-relaxed text-zinc-500">
									Para fazer sua cotação, por favor, entre em
									contato com nosso WhatsApp.
								</p>
							</div>

							<div className="space-y-8 rounded-2xl border border-zinc-200 bg-zinc-50 p-8 shadow-sm transition-colors duration-300 hover:border-green-200">
								<div className="flex flex-col items-center gap-3">
									<div className="mb-1 rounded-full bg-green-100 p-4">
										<Phone className="size-6 text-green-700" />
									</div>
									<p className="text-sm font-medium text-zinc-500">
										Clique no número para abrir ou no ícone
										ao lado para copiar.
									</p>
								</div>

								<CopyWrapper
									valueToCopy={WHATSAPP_NUMBER_COPY}
									wrapperClassName="mx-auto w-fit"
								>
									<p className="pr-8 text-2xl font-bold tracking-tight text-gray-900 md:text-3xl">
										<a
											href={WHATSAPP_LINK_BENEFIT}
											target="_blank"
											rel="noopener noreferrer"
											className="transition-colors hover:text-green-600"
										>
											{WHATSAPP_NUMBER_FORMATTED}
										</a>
									</p>
								</CopyWrapper>

								<a
									href={WHATSAPP_LINK_BENEFIT}
									target="_blank"
									rel="noopener noreferrer"
									className="flex w-full items-center justify-center rounded-xl bg-[#25D366] py-4 font-semibold text-white shadow-md shadow-green-500/20 transition-all hover:bg-[#20bd5a] active:scale-[0.98]"
								>
									Abrir WhatsApp
								</a>
							</div>
						</div>
					</section>
				)}
			</main>

			<Footer />
		</div>
	);
};
